import React, { useEffect } from "react";
import PropTypes, { string } from "prop-types";
import classNames from "classnames";
import "./style.scss";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import AccordionWrapper from "../../elements/accordion-wrapper";

import { useDispatch, useSelector } from "react-redux";
import TimeAndDate from "../time-and-date";
import { setCarBookingProgressAction } from "../../redux/actions/car-booking";
import { carBookingProgressSelector } from "../../selectors/car-booking";
import QAAccordionList from "../../sections/qa-accordion-list";
import LoadingSpinner from "../../elements/loading-spinner";
import TextContent from "../../components/TextContent";

const CarDatePicker = ({ fields, customerNotMatch, showLoading, location, timeAndDateDetails }) => {
  const { headingType, headingBody, body, locationHeadingType, locationHeadingBody, qaItems, customerNotMatchContent } = fields;

  return (
    <section className="date-picker">
      <Heading type={headingType} html={headingBody} typographyClass="type-h3" className="heading" />
      <BodyText html={body.value} />
      {customerNotMatch && customerNotMatchContent && <TextContent {...customerNotMatchContent} className="customer-not-match-content" />}
      {!customerNotMatch && showLoading && <LoadingSpinner />}
      {!customerNotMatch && !showLoading && (
        <>
          <div className="location">
            <Heading type={locationHeadingType} html={locationHeadingBody} typographyClass="type-h4" className="location-heading" />
            <BodyText html={location} className="location-body-text" />
          </div>
          <TimeAndDate fields={fields} {...timeAndDateDetails} />
        </>
      )}
      <QAAccordionList items={qaItems} />
    </section>
  );
};

export default CarDatePicker;
